export const INSERT_PLAN_CATEGORIES = 'INSERT_PLAN_CATEGORIES'
export const SET_SELECTED_CATEGORY_SLUG = 'SET_SELECTED_CATEGORY_SLUG'

export const insertPlanCategories = (
  categories,
  includeFeaturedProducts = false
) => {
  return {
    type: INSERT_PLAN_CATEGORIES,
    categories,
    includeFeaturedProducts
  }
}

export const setSelectedCategorySlug = slug => {
  return {
    type: SET_SELECTED_CATEGORY_SLUG,
    slug
  }
}
